'use client';

import { deleteLayer } from '@/legacy/components/apps/ClientModalProvider';
import { useSetFreeze } from '@/legacy/components/apps/Freeze';
import styles from '@/legacy/components/apps/modal.module.scss';
import { clc, type BaseProps } from '@/legacy/components/base/utils';
import { useEffect, useState } from 'react';

type DivType = BaseProps['div'];

export interface ClientModalProps extends DivType {
	/** 필수 */
	modalKey: string;
	/** 외부 영역 클릭 시 모달 닫힘 여부 */
	outsideDismiss?: boolean;
	/** Esc 클릭 시 모달 닫힘 */
	escapeActive?: boolean;
	/** 닫힐 때 실행할 함수 넣고 싶으면 */
	onCloseTrigger?: () => void;
	/** 모달 활성화 시 창닫 */
	freeze?: boolean;
}

const ClientModal = ({
	children,
	outsideDismiss = true,
	className,
	onCloseTrigger,
	escapeActive = false,
	modalKey,
	freeze = true,
	...props
}: ClientModalProps) => {
	const setFreeze = useSetFreeze();

	const [closing, setClosing] = useState(false);
	// const deleteList = useAtomValue(deleteAtom)
	// const test = deleteList.get(modalKey)
	// console.log('🚀 ~ test:', test, modalKey)

	useEffect(() => {
		const scrollbarWidth = window.innerWidth - document.body.clientWidth;
		const root = document.documentElement;
		root.style.setProperty('--scroll', scrollbarWidth + 'px');
		setFreeze(freeze);

		const handleKeyPress = (event: KeyboardEvent) => {
			if (escapeActive && event.code === 'Escape') {
				setClosing(true);
				deleteLayer(modalKey);
			}
		};
		window.addEventListener('keydown', handleKeyPress);

		return () => {
			setClosing(false);
			setFreeze(false);
			onCloseTrigger && onCloseTrigger();
			window.removeEventListener('keydown', handleKeyPress);
		};
	}, []);

	function onDismiss() {
		if (outsideDismiss) {
			setClosing(true);
			deleteLayer(modalKey);
		}
	}

	return (
		<div
			{...props}
			className={clc(styles.modal_backdrop, className, closing && styles.close)}
			onClick={(e) => {
				if (e.currentTarget === e.target) {
					onDismiss();
					props.onClick && props.onClick(e);

					e.preventDefault();
				}
			}}
			onTouchEnd={(e) => {
				if (e.currentTarget === e.target) {
					onDismiss();
					props.onTouchEnd && props.onTouchEnd(e);
					e.preventDefault();
				}
			}}
		>
			{children}
		</div>
	);
};

export default ClientModal;
